
/*
	Each template entry can control the following for each image:

	* x: x-coord as a percentage of the width of the canvas, eg: 10
	* y: y-coord as a percentage of the height of the canvas, eg: 90
	* s: size of the image as a percentage of the width of the canvas, eg: 20
	* h: (optional) flip horizintal, eg: h: true
	* v: (optional) flip vertical, eg: v: true
	* a: (optional) alpha value, eg: 0.05
	* p: (optional) rendering mode, ['ABSOLUTE', 'CENTER], default is 'CENTER'
	* z: (optional) z-index - set to order the layer application

	Each entry is in the order that we apply them to the supplied images, ie: lead image first

*/

/*
	IMPORTANT

	* Entries are grouped by the number of images it shows, then an ordered list of templates, which will be shown in order in the UI.
	* Each template has a unique name within the number of images group.


*/

//	Template enums - do not alter the names, but feel free to add new names if needed.

const templateNames = {
	cadelEvans: 'cadelEvans',
	chrisFroome: 'chrisFroome'
}

module.exports = {
	templateNames,

	kitItemTemplates: {
		1: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 50, y: 50, s: 100 }
				]
			}
		],
		2: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 25, y: 50, s: 50 },
					{ x: 75, y: 50, s: 50 }
				]
			}
		],
		3: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 50, y: 25, s: 50 },
					{ x: 25, y: 75, s: 50 },
					{ x: 75, y: 75, s: 50 }
				]
			},
			{
				name: templateNames.chrisFroome,
				entries: [
					{ x: 50, y: 25, s: 45 },
					{ x: 25, y: 75, s: 45, r: -10 },
					{ x: 75, y: 75, s: 45, r: 10 }
				]
			}
		],
		4: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 25, y: 25, s: 50 },
					{ x: 75, y: 25, s: 50 },
					{ x: 25, y: 75, s: 50 },
					{ x: 75, y: 75, s: 50 }
				]
			},
			{
				name: templateNames.chrisFroome,
				entries: [
					{ x: 25, y: 25, s: 40, r: 10 },
					{ x: 75, y: 25, s: 40, r: -10 },
					{ x: 25, y: 75, s: 40, r: -10 },
					{ x: 75, y: 75, s: 40, r: 10 }
				]
			}
		],
		5: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 50, y: 50, s: 50 },
					{ x: 15, y: 15, s: 30 },
					{ x: 85, y: 15, s: 30 },
					{ x: 85, y: 85, s: 30 },
					{ x: 15, y: 85, s: 30 }
				]
			},
			{
				name: templateNames.chrisFroome,
				entries: [
					{ x: 50, y: 50, s: 66 },
					{ x: 15, y: 15, s: 28, r: 10 },
					{ x: 85, y: 15, s: 28, r: -10 },
					{ x: 85, y: 85, s: 28, r: 10 },
					{ x: 15, y: 85, s: 28, r: -10 }
				]
			}
		],
		6: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 50, y: 50, s: 66 },
					{ x: 15, y: 15, s: 28, r: 10 },
					{ x: 85, y: 15, s: 28, r: -10 },
					{ x: 10, y: 50, s: 15 },
					{ x: 85, y: 85, s: 28, r: 10 },
					{ x: 15, y: 85, s: 28, r: -10 }
				]
			}
		],
		7: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 50, y: 50, s: 60 },
					{ x: 15, y: 15, s: 28, r: 10 },
					{ x: 85, y: 15, s: 28, r: -10 },
					{ x: 10, y: 50, s: 15 },
					{ x: 90, y: 50, s: 15 },
					{ x: 85, y: 85, s: 28, r: 10 },
					{ x: 15, y: 85, s: 28, r: -10 }
				]
			},
			{
				name: templateNames.chrisFroome,
				entries: [
					{ x: 50, y: 50, s: 60, z: 100 },
					{ x: 15, y: 15, s: 30, r: -35 },
					{ x: 85, y: 15, s: 30, r: 35 },
					{ x: 10, y: 50, s: 20, z: 9 },
					{ x: 90, y: 50, s: 20, z: 10 },
					{ x: 85, y: 85, s: 30, r: -35 },
					{ x: 15, y: 85, s: 30, r: 35 }
				]
			}
		],
		8: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 50, y: 50, s: 55 },
					{ x: 15, y: 15, s: 28, r: 10 },
					{ x: 50, y: 10, s: 15 },
					{ x: 85, y: 15, s: 28, r: -10 },
					{ x: 10, y: 50, s: 15 },
					{ x: 90, y: 50, s: 15 },
					{ x: 85, y: 85, s: 24, r: 10 },
					{ x: 15, y: 85, s: 24, r: -10 }
				]
			},
			{
				name: templateNames.chrisFroome,
				entries: [
					{ x: 50, y: 50, s: 60, z: 100 },
					{ x: 15, y: 15, s: 30, r: -35 },
					{ x: 50, y: 10, s: 15 },
					{ x: 85, y: 15, s: 30, r: 35 },
					{ x: 10, y: 50, s: 20, z: 9 },
					{ x: 90, y: 50, s: 20, z: 10 },
					{ x: 85, y: 85, s: 24, r: -35 },
					{ x: 15, y: 85, s: 24, r: 35 }
				]
			}
		],
		9: [
			{
				name: templateNames.cadelEvans,
				entries: [
					{ x: 50, y: 50, s: 55 },
					{ x: 15, y: 15, s: 28, r: 10 },
					{ x: 40, y: 10, s: 15 },
					{ x: 60, y: 10, s: 15 },
					{ x: 85, y: 15, s: 28, r: -10 },
					{ x: 10, y: 50, s: 15 },
					{ x: 90, y: 50, s: 15 },
					{ x: 85, y: 85, s: 24, r: 10 },
					{ x: 15, y: 85, s: 24, r: -10 }
				]
			},
			{
				name: templateNames.chrisFroome,
				entries: [
					{ x: 50, y: 50, s: 60, z: 100 },
					{ x: 15, y: 15, s: 30, r: -35 },
					{ x: 40, y: 10, s: 15 },
					{ x: 60, y: 10, s: 15 },
					{ x: 85, y: 15, s: 30, r: 35 },
					{ x: 10, y: 50, s: 20, z: 9 },
					{ x: 90, y: 50, s: 20, z: 10 },
					{ x: 85, y: 85, s: 24, r: -35 },
					{ x: 15, y: 85, s: 24, r: 35 }
				]
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/utilities/kitItemTemplates.js